import { RegisterFormFields } from '../hooks';
import { BooleanString } from '../model';
import { HttpClient } from './HttpClient';

interface AuthResponseUser {
  card_number: string;
  duplicate: null;
  old_card_number: string | null;
  child: BooleanString;
  legal_first_name: string;
  legal_last_name: string;
  first_name: string;
  second_name: string;
  last_name: string;
  citizenship: string;
  pesel: string;
  birthdate: string;
  email: string;
  phone: string;
  country: string;
  city: string;
  street: string;
  post_code: string;
  residence_correspondence_address: BooleanString;
  country_correspondence: string;
  city_correspondence: string;
  street_correspondence: string;
  post_code_correspondence: string;
  created_at: string;
  updated_at: string;
  phone_prefix: string;
  voivodeship: string;
  voivodeship_other: string;
  require_approve: number;
  newsletter: BooleanString;
  status: null;
  uuid: null;
  is_valid: boolean;
  can_pay: boolean;
  meta: {
    access_token: string;
  };
}

export interface PassportLoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  user: AuthResponseUser;
}

export class AuthApi {
  static async register(params: RegisterFormFields): Promise<AuthResponseUser> {
    const formData = new FormData();
    formData.append('child', params.child ? '1' : '0');
    if (params.legalFirstName) formData.append('legal_first_name', params.legalFirstName);
    if (params.legalLastName) formData.append('legal_last_name', params.legalLastName);
    formData.append('first_name', params.firstName);
    if (params.secondName) formData.append('second_name', params.secondName);
    formData.append('last_name', params.lastName);
    formData.append('citizenship', params.country);
    formData.append('pesel', params.pesel);
    formData.append(
      'birthdate',
      `${params.birthYear}-${params.birthMonth.padStart(2, '0')}-${params.birthDay.padStart(2, '0')}`,
    );
    formData.append('email', params.email);
    formData.append('phone_prefix', params.phonePrefix);
    formData.append('phone', params.phoneNumber);
    formData.append('country', params.country);
    formData.append('city', params.city);
    formData.append('street', `${params.street} ${params.house}`);
    formData.append('post_code', params.postCode);
    formData.append('residence_correspondence_address', '1');
    formData.append('voivodeship', params.voivodeship);
    formData.append('newsletter', params.newsletter ? '1' : '0');
    formData.append('picture', params.photoCrop ? params.photoCrop : params.photo![0]);
    formData.append('structure_id', params.structure);
    formData.append('collection_id', params.contribution);

    if (params.attachment?.length) {
      formData.append('attachment', params.attachment[0]);
    }

    const { data } = await HttpClient.getInstance().post<AuthResponseUser>('/register', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return data;
  }

  static async requestOtp(cardNumber: string): Promise<void> {
    await HttpClient.getInstance().post('/send-code', {
      card_number: cardNumber,
    });
  }

  static async loginByCode(cardNumber: string, code: string): Promise<PassportLoginResponse> {
    const { data } = await HttpClient.getInstance().post<PassportLoginResponse>('/login-by-code', {
      card_number: cardNumber,
      code,
    });
    return data;
  }

  static async logout(): Promise<void> {
    await HttpClient.getInstance().post('/logout');
  }
}